const ABOUT_IOPE = (() => {
    let lenisInstance = null;

    const setInitLenis = () => {
        if (typeof window.Lenis !== 'function') return;
        lenisInstance = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            // wrapper: document.documentElement,
            // content: document.body
        });

        function raf(time) {
            lenisInstance.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);

        // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
        if (typeof ScrollTrigger !== 'undefined') {
            lenisInstance.on('scroll', () => ScrollTrigger.update());
        }
    }

    // ScrollTrigger 공통 옵션
    const ST_defaults = {
        invalidateOnRefresh: true,
        // markers: true
    };

    const setAnimateOnScroll = () => {
        /**
         * data-animate 속성값별 애니메이션 설정
         * HTML: data-animate="fade-up" | "fade-down" | "fade-left" | "fade-right" ...
         */
        const distance = 60;
        const configEffects = {
            'fade-up': {
                from: { y: distance, opacity: 0 },
                onEnter: { y: 0, opacity: 1 },
                onLeave: { y: distance, opacity: 0 }
            },
            'fade-down': {
                from: { y: -distance, opacity: 0 },
                onEnter: { y: 0, opacity: 1 },
                onLeave: { y: -distance, opacity: 0 }
            },
            'fade-left': {
                from: { x: -distance, opacity: 0 },
                onEnter: { x: 0, opacity: 1 },
                onLeave: { x: -distance, opacity: 0 }
            },
            'fade-right': {
                from: { x: distance, opacity: 0 },
                onEnter: { x: 0, opacity: 1 },
                onLeave: { x: distance, opacity: 0 }
            }
        };

        const batchDefaults = {
            ...ST_defaults,
            id: 'animate on scroll',
            start: 'top bottom-=120'
        };

        const tweenDefaults = {
            duration: 1,
            stagger: 0.1,
            overwrite: true
        };

        Object.entries(configEffects).forEach(([value, effect]) => {
            const selector = `[data-animate="${value}"]`;
            const elements = gsap.utils.toArray(selector);
            if (!elements.length) return;

            gsap.set(elements, effect.from);

            ScrollTrigger.batch(elements, {
                ...batchDefaults,
                onEnter: (item) => gsap.to(item, { ...effect.onEnter, ...tweenDefaults }),
                onEnterBack: (item) => gsap.to(item, { ...effect.onEnter, ...tweenDefaults }),
                onLeaveBack: (item) => gsap.to(item, { ...effect.onLeave, ...tweenDefaults })
            });
        });
    }

    const setMissionAnimate = () => {
        const missionSection = document.querySelector('.about-iope__mission');
        if (missionSection) {
            ScrollTrigger.create({
                ...ST_defaults,
                trigger: missionSection,
                id: 'mission',
                start: 'bottom bottom',
                end: 'top top',
                onEnter: () => missionSection.classList.add('is-animated'),
                onEnterBack: () => missionSection.classList.add('is-animated'),
                onLeaveBack: () => missionSection.classList.remove('is-animated')
            });
        }
    }

    const setLegacyAnimate = () => {
        const legacyList = document.querySelector('.about-iope__legacy-list');
        if (!legacyList) return;
        
        const legacyItems = gsap.utils.toArray(legacyList.querySelectorAll('.about-iope__legacy-item'));
        if (!legacyItems.length) return;
        
        const offset = '200';
        ScrollTrigger.create({
            ...ST_defaults,
            trigger: legacyItems[0],
            id: 'legacy',
            start: `top bottom-=${offset}`,
            onEnter: () => legacyList.classList.add('is-animated'),
            onEnterBack: () => legacyList.classList.add('is-animated'),
            onLeaveBack: () => {
                legacyList.classList.remove('is-animated');
                // legacyItems.forEach(item => item.classList.remove('is-active'));
            }
        });

        ScrollTrigger.batch(legacyItems, {
            ...ST_defaults,
            id: 'legacy items',
            start: `top bottom-=${offset}`,
            onEnter: (items) => {
                items.forEach(el => el.classList.add("is-active"));
            },
            onEnterBack: (items) => {
                items.forEach(el => el.classList.add("is-active"));
            },
            onLeaveBack: (items) => {
                items.forEach(el => el.classList.remove("is-active"));
            }
          });
    }

    const setFeaturesNavScroll = () => {
        const navLinks = document.querySelectorAll('.about-iope__features-nav a[href^="#"]');
        const pagination = document.querySelector('.about-iope__features-pagination');
        const paginationLinks = [];
        const anchorElements = document.querySelectorAll('[data-anchor]');
        const anchorOffsets = [];
        let currentIndex = -1;

        const onScrollTo = (e) => {
            const targetId = e.currentTarget.getAttribute('href').replace('#', '');
            const target = document.getElementById(targetId);

            if (target) {
                e.preventDefault();

                if (typeof lenisInstance?.scrollTo === 'function') { // Lenis 사용시
                    lenisInstance.scrollTo(target, {
                        offset: 0,
                        duration: 1,
                        lock: false
                    });
                } else {
                    const scrollY = window.scrollY;
                    const targetTop = target.getBoundingClientRect().top + scrollY;

                    window.scrollTo({
                        top: targetTop,
                        behavior: 'smooth'
                    });
                }
            }
        }

        const onScroll = (e) => {
            const scrollY = window.scrollY;
            const threshold = 1;

            anchorOffsets.forEach((anchor, index) => {
                const start = anchor.top - threshold; // 소수점으로 인한 차이 때문에 -threshold 추가
                const end = anchor.bottom;

                if (scrollY >= start && scrollY < end) {
                    currentIndex = index;
                }
            });

            // console.log(currentIndex);

            if (currentIndex >= 0) {
                paginationLinks.forEach((link, i) => {
                    link.classList.toggle('features-pagination__link--active', i === currentIndex);
                });
            }

            // 첫 번째 앵커 도달 이후 pagination 노출
            if (pagination && anchorOffsets.length > 0) {
                const pastFirstAnchor = scrollY >= anchorOffsets[0].top - threshold;
                pagination.classList.toggle('is-active', pastFirstAnchor);
            }
        };

        const setNavigation = () => {
            navLinks.forEach((link, index) => {
                if (pagination) {
                    // pagination 버튼 자동 생성
                    pagination.insertAdjacentHTML(
                        'beforeend',
                        `<a class="features-pagination__link"
                            href="${link.getAttribute('href')}"
                            ap-click-area="${link.getAttribute('ap-click-area')}"
                            ap-click-name="Click - Dot"
                            ap-click-data="${link.getAttribute('ap-click-data')}"
                        >
                            <span class="visually-hidden">${link.textContent}</span>
                        </a>`
                    );

                    paginationLinks[index] = pagination.lastElementChild;
                }
    
                link.addEventListener('click', onScrollTo);
            });

            // pagination 버튼 초기 설정
            paginationLinks.forEach((link, index) => {
                link.addEventListener('click', onScrollTo);
            });
        }

        const setOffsets = () => {
            const scrollY = window.scrollY;

            anchorElements.forEach((anchor, index) => {
                const element = anchor;
                const rect = anchor.getBoundingClientRect();
                const top = rect.top + scrollY;
                const bottom = top + rect.height;

                anchorOffsets[index] = { element, rect, top, bottom };
            });

            // console.log(anchorOffsets);
        }

        const onUpdate = () => {
            setOffsets();
        };

        const onInit = () => {
            onUpdate();
            onScroll();
            setNavigation();

            // 이벤트 리스너 설정
            window.addEventListener('scroll', _.throttle(onScroll, 100));
            window.addEventListener('resize', _.debounce(onUpdate, 150));            
        };

        onInit();
    }

    const setInitGSAP = () => {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

        ScrollTrigger.config({
            // limitCallbacks: true,    // 타이밍 이슈로 옵션 비활화 -> 테스트 필요
            ignoreMobileResize: true
        });

        setAnimateOnScroll();
        setMissionAnimate();
        setLegacyAnimate();
    }

    const onInit = () => {
        setInitLenis();
        setInitGSAP();
        setFeaturesNavScroll();
    };

    return {
        init: onInit
    };
})();

ABOUT_IOPE.init();

window.addEventListener('load', function () {
    if (typeof ScrollTrigger !== 'undefined') {
        requestAnimationFrame(() => ScrollTrigger.refresh());
    }
});
